import { IScaffoldActionColEnterComplete, ScaffoldState } from "./interface";

/**
 * Handles the COL_ENTER_COMPLETE action by removing the specified column id from
 * the enteringColIds set once its entry animation has finished.
 * Returns the unchanged state if the column id is not present in the set.
 *
 * @param action - The COL_ENTER_COMPLETE action carrying the id of the column that finished animating in.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the completed entering column removed from enteringColIds,
 *          or the unchanged state if the id was not present.
 */
export const scr_colEnterComplete = <T>(
  action: IScaffoldActionColEnterComplete,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  if (!state.enteringColIds.has(action.colId)) {
    return state;
  }

  const next = new Set(state.enteringColIds);
  next.delete(action.colId);
  return { ...state, enteringColIds: next };
};
